import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  topup: { member: "", amount: 0 },
  withdraw: { member: "", amount: 0 },
  transactions: { action: "" },
};

const transactionSlice = createSlice({
  name: "transaction",
  initialState,
  reducers: {
    selectCustomerTopup: (state, { payload }) => {
      state.topup.member = payload;
    },
    selectCustomerWithdraw: (state, { payload }) => {
      state.withdraw.member = payload;
    },
    onChangeAmountTopup: (state, { payload }) => {
      state.topup.amount = payload;
    },
    onChangeAmountWithdraw: (state, { payload }) => {
      state.withdraw.amount = payload;
    },
    clearTopup: (state) => {
      state.topup = initialState.topup;
    },
    clearWithdraw: (state) => {
      state.withdraw = initialState.withdraw;
    },
    clearTransaction: (state) => {
      state.withdraw = initialState.withdraw;
      state.topup = initialState.topup;
      state.transactions = initialState.transactions;
    },
  },
});

export const {
  selectCustomerTopup,
  selectCustomerWithdraw,
  onChangeAmountTopup,
  onChangeAmountWithdraw,
  clearTopup,
  clearWithdraw,
  clearTransaction,
} = transactionSlice.actions;

export default transactionSlice.reducer;
